<app-card>
  <div>
    <div i18n class="headline">Feedback last 30 days</div>
    <div i18n class="subheadline">Entries across all features</div>
  </div>
  <app-graph [data]="data()" [options]="options" type="line" />
</app-card>
